var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm4.32 13.65-.7.7a.5.5 0 0 1-.71 0l-3.79-3.79a.47.47 0 0 1-.15-.35V5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v5.88a.47.47 0 0 0 .15.35l3.2 3.21a.5.5 0 0 1 .03.71Z"
})));
export default SvgClock;